import { graphql } from 'gatsby';
import React from 'react';
import LitStructuredText from './generic/LitStructuredText';
const ModularHeading = ({ data }) => {
  const { backgroundColor, idContent, heading, noBottomPadding, noTopPadding } =
    data;
  return (
    <div
      className={`modular-heading-container ${backgroundColor} ${
        noBottomPadding && 'modular-padding-large-no-bottom'
      } ${noTopPadding && 'modular-padding-large-no-top'} ${
        !noBottomPadding && !noBottomPadding && 'modular-padding-large'
      }`}
      id={idContent}
    >
      <div
        className={`modular-heading-secondary modular-text-center modular-global-width`}
      >
        <LitStructuredText data={heading} basic />
      </div>
    </div>
  );
};

export default ModularHeading;
export const fragment = graphql`
  fragment ModularHeading on DatoCmsHeading {
    internal {
      type
    }
    noBottomPadding
    noTopPadding
    backgroundColor
    idContent
    heading {
      value
    }
  }
`;
